import { render, staticRenderFns } from "./onebox-directorysharefile.vue?vue&type=template&id=1b6d53ba&"
import script from "./onebox-directorysharefile.vue?vue&type=script&lang=js&"
export * from "./onebox-directorysharefile.vue?vue&type=script&lang=js&"
import style0 from "./onebox-directorysharefile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports